export const emails = {
  experience: "experience@conectasuite.com",
  suporte: "suporte@conectasuite.com",
  ti: "ti@conectanuvem.com.br",
  financial: "financeiro@conectasuite.com",
};

export const telephone = "+55 (48) 3036-1096";
